import withConfigTransport from '../../../services/config-transport/withConfigTransport'
import SquareWithIcon from './SquareWithIcon.vue'

export default withConfigTransport(SquareWithIcon as any)
